export const CIRCUITS_TRANSLATIONS_FR: any = {
    templates: {
        workflow01: {
            name: 'Processus de signature du contrat de travail / avenant',
            actors: {
                provider: 'Fournisseur',
                subscriber: 'Souscripteur'
            },
            transactions: {
                subscriber_transaction: {
                    title: 'Vos documents précontractuels et contractuels à signer'
                },
            },
            tasks: {
                signature_subscriber: {
                    title: {
                        subscriber: 'Signature des documents par le souscripteur'
                    },
                    steps: {
                        validate: {
                            title: 'Lecture et validation des documents'
                        },
                        signature: {
                            title: 'Lecture et signature des documents'
                        }
                    }
                }
            }
        },
        workflow02: {
            name: 'Processus de signature du contrat de travail / avenant',
            actors: {
                provider: 'Fournisseur',
                subscriber: 'Souscripteur'
            },
            transactions: {
                subscriber_transaction: {
                    title: 'Vos documents précontractuels et contractuels à signer'
                },
            },
            tasks: {
                signature_subscriber: {
                    title: {
                        subscriber: 'Signature des documents par le souscripteur'
                    },
                    steps: {
                        validate: {
                            title: 'Lecture des documents précontractuels et contractuels',
                            titleOneDocument: `Lecture et validation du document`
                        },
                        signature: {
                            title: 'Signer les documents précontractuels et contractuels',
                            titleOneDocument: `Signature du document`
                        }
                    }
                }
            }
        }
    },
    // StepValidateSequentialComponent
    validate_step: {
        submit: 'Valider',
        reject: 'Refuser le dossier',
        dialog: {
            reject: {
                title: 'Rejeter le dossier',
                reason: 'Veuillez saisir un motif'
            },
            force_reading: {
                title: 'Lire le document',
                message: 'Vous devez lire le document en entier, pour ce faire défilez jusqu’à la dernière page.'
            }
        }
    },
    circuit: {
        compris: 'J\'ai compris',
        lu: 'J\'ai lu le document',
        lu_signe: 'J\'ai lu le document et je signe',
        task: {
            task_successfully_submitted: '<span class="uppercase">Contrat signé</span><br/><br/><small>Merci d’avoir choisi la Banque Postale !</small>',
            task_successfully_sign: 'Contrat signé',
            task_successfully_sign_hd: 'Processus terminé avec succès, veuillez patienter',
            task_successfully_thanks: 'Merci d’avoir choisi La Banque Postale !',
            sign: 'Signer',
            saisirCode: 'Saisir le code reçu par SMS',
            renvoyerCode: 'Renvoyer un code'
        },
        dialog: {
            delete: {
                label: 'Supprimer le parcours',
                delete_confirm: 'Cette opération est irreversible. Êtes-vous sûr de vouloir supprimer le parcours ?'
            }
        },
        qr_1: '<p>Scanner ce QR code pour poursuivre la signature sur votre téléphone mobile</p><p>ou</p><p>Cliquez le bouton j\'ai compris pour poursuivre la lecture sur un ordinateur</p>'
    },
    bo_circuits: {
        list: {
            expires_close: 'Le parcours expire dans moins de quatre jours',
            expires_soon: 'Le parcours expire dans moins de sept jours',
        },
        details: {
            back_button_label: 'Retourner sur l\'écran de gestion des parcours',
            titleLbpa: 'Assurance des Accidents de la Vie : ',
            global: {
                circuit_title: 'Contrat',
                clientRef: 'Numéro de contrat',
                created_date: 'Date de création du dossier',
                expired_date: 'Date limite de signature',
                client_reference: 'Référence client',
                souscripteur: 'Souscripteur'
            },
            workflow: {
                title: 'Avancement du parcours'
            }
        }
    },
    fo_standard_action: {
        circuit_list: 'Gérer les parcours'
    },
    fo_circuits: {
        dossierDataTable: {
            noData: '<p>Vous n’avez aucune proposition en attente de signature électronique.<br/>Pour consulter les propositions expirées ou terminées, merci d’utiliser le filtre statut de la barre de filtre.</p>',
            documents: 'proposition(s)'
            // documents: 'total'
        },
        list: {
            title: 'Suivre l\'évolution du statut des propositions et contrats',
            subscriber: 'Nom client',
            column_subscriber: 'Souscripteur',
            column_name: 'Contrat',
            clientRef: 'N° Contrat',
            bgp: 'BGP',
            column_id_rh: 'ID RH',
            column_devis_contrat: 'N° Devis/Contrat',
            column_signature_limit: 'Date limite de signature',
            actions: {
                cancel: 'Annuler le parcours',
                delete: 'Supprimer le parcours'
            }
        }
    },
    back_office: {
        component: {
            date_filter: {
                placeholder: 'AAAA-MM-JJ'
            }
        }
    },
    account: {
        login: {
            id: 'Identifiant'
        },
        pwd_forget: {
            enter_login: 'Veuillez renseigner votre identifiant *'
        }
    },
    password: {
        expiration: 'Votre mot de passe expirera dans {{days}} jours. Pour le réinitialiser, merci de cliquer sur "Mot de passe oublié ou compte bloqué ?" sur l\'écran de connexion.'
    },
    pes: {
        profile: {
            conseiller_admin: 'Administrateur conseiller'
        },
        header: {
            logo_title: 'Aller sur votre espace personnel',
            alt_logo: 'Logo La Banque Postale'
        }
    },
    lbpa: {
        redirect: 'Vous serez redirigé dans quelques secondes',
        // lu_accept: 'J’ai lu et j’accepte sans réserve les <a href="assets/cgu/cgu_contralia.pdf" target="_blank" title="Conditions Générales d’Utilisation (nouvelle fenêtre)">Conditions Générales d’Utilisation</a> de la signature électronique de Contralia.',
        lu_accept: 'J’ai lu et j’accepte sans réserve les Conditions Générales d’Utilisation de la signature électronique de Contralia.',
        modals: {
            welcome: {
                title: 'Deux étapes pour signer mon contrat',
                titleSante: 'Signature de mon questionnaire de santé',
                submit: 'J\'ai compris',
                readLabel: 'Lire',
                signLabel: 'Signer',
                read: 'Les documents précontractuels et contractuels de votre contrat d\'assurance vous sont présentés. Vous avez la possibilité de lire chaque document en le faisant défiler. Pour passer au document suivant, cliquez sur le bouton "J\'ai lu le document"',
                rules: `Vous devez prendre connaissance et vérifier l'intégralité du document avant de procéder à sa signature électronique`,
                barre: 'Vous visualisez via cette barre de navigation le nombre de documents présentés et vous pouvez à tout moment revenir sur un document en cliquant sur le numéro correspondant. ',
                barreAlt: 'Barre de navigation présentant le nombre de documents',
                sign: 'Vous signez l\'ensemble de vos documents en saisissant le code unique que vous recevrez par SMS',
                signHelp: `La signature de votre questionnaire de Santé est obligatoire. Elle se réalise de façon simple et sécurisée par la saisie d'un code unique que vous recevrez par SMS`,
                ios_compatibility: 'Si vous êtes équipés d’une version iOS antérieure à 14.7, merci de mettre à jour votre téléphone ou de privilégier la signature depuis un ordinateur.'
            }
        }
    },
    component: {
        timeline: {
            cancel_with_status: 'Parcours annulé par {{user}} le {{ date }} - Motif : {{ reason }}'
        }
    },
    circuit_status: {
        title: 'Statut des parcours',
        total: 'Total'
    }
};



// WEBPACK FOOTER //
// ./src/app/i18n/fr-FR/circuits-translations.fr.ts